/**
 * 根据list的field配置输出快速查询，高级查询 ，单独放出条件的查询
 * 快速查询的输出有两种方式：1.把查询条件合并放入到一个下拉选择项中去输出 2.以动态字段的方式去输出
 * 快速查询-合并到下拉选择项中输出 结构：[{id:"filtermode",type:"select",subdata:[]}] 通过changehandler隐藏显示字段的方式
 * 快速查询-动态字段输出 [{id:"",dynamicConfig:"[]"}] 把字段放到组件的动态执行change的时候重新初始化表单
 */
import { fieldSortFunc } from './field-sort';//排序
declare const window:any;
export const queryListFieldFunc:Function = function(fieldArray:[],options:{ajaxData:{},sortField:string,id:string,source:string,outputType:string,isUseSelectQuickSearch:boolean,quickQueryGroupNumber:number,queryModeType?:string}){
    const resultObject:any = {
        advanceForm:[],//高级查询
        advanceValue:{},//高级查询默认输出值
        form:[],//展开多个输出
        quicklyQueryColumnNames:[],//快速查询的字段
        querySubData:[],//查询下拉列表 [{text:"按名称查询",value:"name"}...]
        dynamicSubData:[],//动态字段的形式输出
        type:options.queryModeType,//输出形式
        id:options.id,
        queryId:'query-'+options.id,
        advanceId:'advance-query-'+options.id,
    };
    const i18n = window.NetStarUtils.getI18n(window.NetStarUtils.I18N);
    const sortField:string = options.sortField ? options.sortField : 'queryOrder';//排序字段
    const quickQueryGroupNumber:number = options.quickQueryGroupNumber;//输出查询条件的个数
    const isUseSelectQuickSearch:boolean = quickQueryGroupNumber > 1 ? false : options.isUseSelectQuickSearch;//查询条件输出两个以上的时候禁止输出快速查询
    const newFieldArray:any = window.NSUtils.deepCopy(fieldArray);//先克隆保留原始入参不变
    fieldSortFunc(newFieldArray,sortField,options.ajaxData);//按照数值类型进行字段升序排序
    for(let fieldI=0; fieldI<newFieldArray.length; fieldI++){
        const fieldData:any = newFieldArray[fieldI];
        const searchable:boolean = typeof(fieldData.searchable) == 'boolean' ? fieldData.searchable : false;//是否配置了支持搜索
        const isSearchUseEditConfig = typeof (fieldData.isSearchUseEditConfig) == 'boolean' ? fieldData.isSearchUseEditConfig : false;//搜索是否强制使用editConfig中的配置
        const isQuickQuery:boolean = typeof(fieldData.isSupportQuickQuery) == 'boolean' ? fieldData.isSupportQuickQuery : true;//是否支持快速查询
        const isAsQuickQueryField = typeof(fieldData.isQuickQuery)=='boolean' ? fieldData.isQuickQuery : false;//查询的时候是否作为快速查询参数发送
        const editConfig:any = typeof(fieldData.editConfig)=='object' ? fieldData.editConfig : {};
        const idStr:string = fieldData.field;//id字段
        const componentType:string = editConfig.type ? editConfig.type : 'text';//默认按文本
        const isAloneQuery:boolean = typeof(editConfig.isAloneQuery) == 'boolean' ? editConfig.isAloneQuery : false;
        if(isAsQuickQueryField === true){
            resultObject.quicklyQueryColumnNames.push(idStr);//快速查询的字段
        }
        if(searchable === true){
            let textStr:string = fieldData.isTreeNode === true ? fieldData.chineseName : (fieldData.title ? fieldData.title : idStr);//如果没有定义标题输出则读取field
            textStr = window.jQuery.trim(textStr);//去除空格
            let showTextStr = window.NetStarUtils.getI18nTipsStr(i18n.conditionQuery,{condition:textStr});
            /***********快速查询 start**************** */
            const businessConfig:any = typeof(fieldData.businessConfig)=='object' ? fieldData.businessConfig : {};//业务组件
            let quickQueryConfig:any = window.NSUtils.deepCopy(editConfig);//克隆组件配置
            let advanceQueryConfig:any = window.NSUtils.deepCopy(editConfig);//高级查询
            if(isSearchUseEditConfig === false){
                //不是强制使用配置可针对类型进行一些转换处理
                switch(componentType){
                    case 'textarea':
                    case 'text':
                        if(editConfig.isUseTextRange === true) {
                            quickQueryConfig.type = 'textRange';
                        }
                        break;
                    case 'radio':
                        quickQueryConfig.type = 'select';//快速查询如果输出radio和checkbox输出字段太长，所以转换成下拉去输出
                        break;
                    case 'checkbox':
                        quickQueryConfig.type = 'select';//快速查询如果输出radio和checkbox输出字段太长，所以转换成下拉去输出
                        quickQueryConfig.selectMode = 'multi';//多选输出
                        break;
                    case 'number':
                        quickQueryConfig.type = 'numberRange';//快速查询-输出数字区间
                        advanceQueryConfig.type = 'numberRange';
                        break;
                    case 'date':
                        if(editConfig.isSaveDateRange === false){
                            quickQueryConfig.type = 'dateRangePicker';
                            quickQueryConfig.isRelativeTime = true;
                            advanceQueryConfig.type = 'dateRangePicker';
                            advanceQueryConfig.isRelativeTime = true;
                        }
                        break;
                    default:
                        break;
                }
            }
            if(fieldData.columnType == 'business' || fieldData.columnType == 'businessSelect'){
                advanceQueryConfig = businessConfig;
                quickQueryConfig = businessConfig;
            }
            advanceQueryConfig.id = idStr;
            advanceQueryConfig.label = textStr;
            if(isAloneQuery === false && isQuickQuery){
                resultObject.querySubData.push({
                    text:textStr,
                    value:idStr
                });
                resultObject.advanceForm.push(advanceQueryConfig);
                resultObject.form.push(advanceQueryConfig);
                delete quickQueryConfig.label;
                quickQueryConfig.isAllowJumpNext = false;
                quickQueryConfig.id = quickQueryConfig.id ? quickQueryConfig.id : idStr;
                resultObject.dynamicSubData.push({
                    text:showTextStr,
                    value:idStr,
                    dynamicConfig:JSON.stringify([quickQueryConfig])
                });
            }
            let valueStr = advanceQueryConfig.value;
            switch (advanceQueryConfig.type) {
                case "dateRangePicker":
                    if(typeof(valueStr)=='string'){
                        if(valueStr === ''){
                            if(advanceQueryConfig.defalutPresetValue || advanceQueryConfig.defaultPresetValue){
                                valueStr = advanceQueryConfig.defalutPresetValue ? advanceQueryConfig.defalutPresetValue : advanceQueryConfig.defaultPresetValue;
                            }
                        }
                    }else if(typeof(valueStr)=='undefined'){
                        if(advanceQueryConfig.defalutPresetValue || advanceQueryConfig.defaultPresetValue){
                            valueStr = advanceQueryConfig.defalutPresetValue ? advanceQueryConfig.defalutPresetValue : advanceQueryConfig.defaultPresetValue;
                        }
                    }
                    break;
                default:
                    break;
            }
            if (typeof (valueStr) != "undefined" && valueStr !== '') {
                switch (advanceQueryConfig.type) {
                    case "dateRangePicker":
                        if(typeof(valueStr)=='object'){
                            resultObject.advanceValue[advanceQueryConfig.id] = valueStr;
                        }else{
                            var valueObj = window.NetstarComponent.dateRangePicker.getDataByMark(valueStr,{languageType:"zh"});
                            if(!window.jQuery.isEmptyObject(valueObj)){
                                resultObject.advanceValue[advanceQueryConfig.id+'Start'] = valueObj.start;
                                resultObject.advanceValue[advanceQueryConfig.id+'End'] = valueObj.end;
                            }
                        }
                        break;
                    default:
                        resultObject.advanceValue[advanceQueryConfig.id] = valueStr;
                        break;
                }
            }
        }
    }
    if(isUseSelectQuickSearch === true){
        resultObject.querySubData.unshift({
            text:i18n.quickQuery,
            value:"filtermode"
        });
        resultObject.dynamicSubData.unshift({
            text:i18n.quickQuery,
            value:"filtermode",
            dynamicConfig:JSON.stringify([{id:"filterstr",type:"text"}])
        });
    }
    return resultObject;
}